/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../../Common/DataTableFilter";
import { useNavigate } from "react-router-dom";
import { WebSocketContext } from "../../../App";
import { ADD_PINCODES_URL } from "../../Shared/constant";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonTable from "../../Common/CommonTable";

const Pincodes = (props) => {
    const { pincodeList, device_id } = useSelector((state) => state.adminReducers);
    const { websocket } = useContext(WebSocketContext);
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const [ userSearch, setUserSearch ] = useState("");
    const [ userType, setUserType ] = useState("");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };

    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // get all city
    useEffect(() => {
        let param = { 
            "transmit": "broadcast", 
            "url": "state_list",
            "request" : { 
                "status" : "", 
                "limit" : 5000,
                "page_no" : 1, 
                "search" : ""
            },
            "DeviceId" : device_id
        };
        wsSend_request(websocket, param);
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        let param = { 
            "transmit": "broadcast", 
            "url": "pin_code_list",
            "request" : { 
                "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                "limit" : userLimit,
                "page_no" : currentPage, 
                "search" : userSearch.trim()
            },
            "DeviceId" : device_id
        };
        wsSend_request(websocket, param);
    };

    // when page load api calling
    useEffect(() => {
        APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit ]);

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // create applications
    const cmnFnct = () => {
        Navigate(ADD_PINCODES_URL);
    };

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'district_id', label: 'State', type: "label_get_state_from_pincodes", filterFrom: { list: "district", label: "state_name" }, sort: "", isCollapsable: false },
        { key: 'district_id', label: 'City', type: "label_get_from_list", filterFrom: { list: "district", label: "district_name" }, sort: "", isCollapsable: false },
        { key: 'pin_code', label: 'Pincode', type: "label", sort: "", isCollapsable: false },
        { key: 'district_id', label: 'GST code', type: "label_get_gst_from_pincodes", filterFrom: { list: "district", label: "state_name" }, sort: "", isCollapsable: false },
        { key: 'is_active', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section">
        <DataTableFilter 
            filterType={"Pincodes"}
            searchType={"Pincodes"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={false}
            ButtonSet={{
                buttontitle: "Create Pincodes",
                function: cmnFnct
            }}
            searchdisable={true}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{ height: pincodeList?.pagination?.total_records > 10 ? "calc(100vh - 175px)" : "calc(100vh - 139px)"}} 
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={""} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={pincodeList} // PINCODES LIST
            Pagination={pincodeList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={false} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: false,
                label: "edit",
                naviagte: ``
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default Pincodes;